import { render } from "./UeCoalDtListView.vue?vue&type=template&id=0bf85791&scoped=true"
import script from "./UeCoalDtListView.vue?vue&type=script&lang=js"
export * from "./UeCoalDtListView.vue?vue&type=script&lang=js"

import "./UeCoalDtListView.vue?vue&type=style&index=0&id=0bf85791&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf85791"]])

export default __exports__